import { render, staticRenderFns } from "./DialogAddBalance.vue?vue&type=template&id=24207145"
import script from "./DialogAddBalance.vue?vue&type=script&lang=ts"
export * from "./DialogAddBalance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports